import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-spinning-loader',
    templateUrl: './spinning-loader.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpinningLoaderComponent implements OnInit
{
    @Input() shown: boolean;
    @Input() text: string;

    constructor() { }

    ngOnInit ()
    {
    }
}
